import { render, staticRenderFns } from "./WorksheetAssessment.vue?vue&type=template&id=be32a23a"
import script from "./WorksheetAssessment.vue?vue&type=script&lang=js"
export * from "./WorksheetAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports